import React, { useCallback } from "react";
import { useSelector } from "react-redux";
import {
  Alert,
  IAlertMonitor,
  PresentationType,
  Reminder,
} from "../../redux/alerts";
import { notificationsToDisplay } from "../../redux/alerts/selectors";

import img_alerts from "../../assets/images/img-alerts.png";

import { useTranslation } from "react-i18next";
import { IAppState } from "../../redux/types";
import { ModalTypes } from "./Callbacks";
import OneNotificationView from "./OneNotificationView";
const MobileContent = (props: any): JSX.Element => {
  const { children } = props;
  const { presentation } = useSelector(
    (state: IAppState) => state.alerts.settings
  );
  return presentation === PresentationType.Cards ||
    presentation === PresentationType.List ? (
    <div
      // flex-column-${presentation === PresentationType.Cards ? "24" : "8"}`}
      className={`notification-list flex-column`}
    >
      {children}
    </div>
  ) : (
    <div className="notification-list flex-tile">{children}</div>
  );
};

const NotificationContent = ({
  callback,
}: {
  callback: (...args: any) => void;
}): JSX.Element => {
  const displayedNotifications = useSelector(notificationsToDisplay);
  const onDoneClick = useCallback(
    (alert: Alert | Reminder) => {
      alert["activityType"] !== undefined
        ? callback(
            ModalTypes.SHOW_ACTIVITY_FEEDBACK,
            alert,
            alert["residentId"]
          )
        : callback(ModalTypes.SHOW_ALERT_FEEDBACK, alert);
    },
    [callback]
  );
  const children = displayedNotifications.map((alert, index) => {
    const isReminder = alert["activityType"] !== undefined;
    const reminder = isReminder ? (alert as Reminder) : undefined;
    const al = !isReminder ? (alert as IAlertMonitor) : undefined;
    return al ? (
      <OneNotificationView
        alert={al}
        key={al?.alertToken + index + al?.patientId}
        onDoneClick={onDoneClick}
        index={index}
      />
    ) : (
      <OneNotificationView
        alert={reminder}
        key={reminder.activityType + index + reminder?.residentId}
        onDoneClick={onDoneClick}
        index={index}
      />
    );
  });

  console.log("NotificationContent");
  if (displayedNotifications.length === 0) return <EmptyViewStatus />;
  return <MobileContent>{children}</MobileContent>;
};

const EmptyViewStatus = () => {
  const { t } = useTranslation("status");
  return (
    <div style={{ marginTop: "10px" }}>
      <div className="flex-column flex-column-16 flex-center">
        <img
          src={img_alerts}
          alt="alerts"
          width={80}
          height={80}
          className="emptyStatus"
        />
        <p>{t("noNotif")}</p>
      </div>
    </div>
  );
};
export default React.memo(NotificationContent);
